/*!
 * Copyright (c) REWE Digital GmbH
 */
import { h } from "@stencil/core";
/**
 * JSON-LD Component for rendering script with LD.
 */
export class VxProductJsonld {
    constructor() {
        /**
         * Build Structure for ProductLD.
         */
        this.buildProduct = () => {
            var _a, _b, _c, _d;
            const { url, title, attributes, manufacturer, content, media, rating, ordernumber, } = this.product;
            const productLd = {
                '@context': 'https://schema.org',
                '@type': 'Product',
                'url': url,
                'gtin13': (_a = attributes === null || attributes === void 0 ? void 0 : attributes.core) === null || _a === void 0 ? void 0 : _a.gtin,
                'sku': ordernumber,
                'manufacturer': manufacturer === null || manufacturer === void 0 ? void 0 : manufacturer.name,
                'name': title,
                'description': content === null || content === void 0 ? void 0 : content.shortDescription,
            };
            if (manufacturer) {
                productLd['brand'] = {
                    '@type': 'Brand',
                    'name': manufacturer === null || manufacturer === void 0 ? void 0 : manufacturer.name,
                    'url': manufacturer === null || manufacturer === void 0 ? void 0 : manufacturer.link,
                    'description': manufacturer === null || manufacturer === void 0 ? void 0 : manufacturer.metaDescription,
                    'image': manufacturer === null || manufacturer === void 0 ? void 0 : manufacturer.coverFile,
                };
            }
            if (media && this.product.media.length > 0) {
                productLd['image'] = this.product.media.map((image) => (image.file));
            }
            productLd['offers'] = {
                '@type': 'Offer',
                'url': this.product.url,
                'name': this.product.title,
                'availability': this.product.isAvailable ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
                'itemCondition': 'https://schema.org/NewCondition',
                'price': (_b = this.product.price) === null || _b === void 0 ? void 0 : _b.gross,
                'priceCurrency': (_c = this.product.price) === null || _c === void 0 ? void 0 : _c.currency,
            };
            if (rating && rating.count > 0) {
                productLd['aggregateRating'] = {
                    '@type': 'AggregateRating',
                    'bestRating': 10,
                    'worstRating': 0,
                    'ratingValue': (_d = rating === null || rating === void 0 ? void 0 : rating.average) === null || _d === void 0 ? void 0 : _d.toFixed(1),
                    'ratingCount': rating === null || rating === void 0 ? void 0 : rating.count,
                };
            }
            return productLd;
        };
        this.product = undefined;
    }
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        return (h("script", { key: 'a994cfd97745d67658dfe9724b70e81c8db61745', type: 'application/ld+json', innerHTML: JSON.stringify(this.buildProduct()) }));
    }
    static get is() { return "vx-product-jsonld"; }
    static get encapsulation() { return "shadow"; }
    static get properties() {
        return {
            "product": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "Product",
                    "resolved": "Product",
                    "references": {
                        "Product": {
                            "location": "import",
                            "path": "@rdss/client",
                            "id": "../client/dist/index.d.ts::Product"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Basis Data for Structured Data."
                }
            }
        };
    }
}
//# sourceMappingURL=vx-product-jsonld.js.map
